import { createAsyncThunk } from '@reduxjs/toolkit';
import { setOrderLeadTimes } from '../operations';
import Api, { FetchParams } from '../utils/Api';

export const fetchOrderLeadTimes = createAsyncThunk(
  '$fetchOrderLeadTimes',
  async (_data: undefined, { dispatch, rejectWithValue }) => {
    try {
      const params: FetchParams = {
        path: '/api/v1/leadtimerules/thresholds',
        method: 'GET',
      };

      const response = await Api.fetch(params);

      const orderLeadTimes: OrderLeadTime[] = response.data;

      dispatch(setOrderLeadTimes(orderLeadTimes));
    } catch (e) {
      console.error('Fetch Order Lead Times failed', { e });
      return rejectWithValue(e);
    }
  },
);
